import {HTH} from "../HTH";
import {gsap} from "gsap";
import {HTHGameConfig} from "../HTHGameConfig";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {HTHHelper} from "../utils/HTHHelper";
import {TimelineSprite} from "@nolimitcity/promo-panel/bin/utils/TimelineSprite";
import {HTHSound} from "../sound/HTHSound";

export class HTHReelAnticipation extends PIXI.Container {
    private _isPlayingAnticipation: boolean;
    private _playingOnReel: boolean[];
    private _animations: TimelineSprite[];
    private _firstCall: number;


    constructor() {
        super();
        this.name = "ReelAnticipation";
        this._isPlayingAnticipation = false;
        this._playingOnReel = ArrayHelper.initArrayWithValues(6, () => false);
        this.init();
        this._firstCall = 0;
    }

    public fadeOut(reelId: number): void {
        this._animations[reelId].stopLoop();
        this._animations[reelId].hide();

    }

    public reset(): void {
        if (HTHGameConfig.isAnticipationPlaying && this._isPlayingAnticipation) {
            HTHSound.stopSound(HTHSound.SCATTER_ANTICIPATION);
            HTHSound.playTrack(HTHSound.SCATTER_ANTICIPATION_ENDS);
            HTHSound.fadeMusic(1, 400);
        }
        this._isPlayingAnticipation = false;
        this._playingOnReel = ArrayHelper.initArrayWithValues(6, () => false);
        this._animations.forEach((animation: TimelineSprite) => {
            animation.hide();
            animation.stopLoop();
        });
        HTH.reelAnticipationTop.reset();
        this._firstCall = 0;
    }


    public playAnticipation(currIndex: number): gsap.core.Timeline {
        const anticipationTL: gsap.core.Timeline = gsap.timeline();
        if (HTHHelper.isFreeSpin(HTH.model.mode)) {
            return anticipationTL;
        }

        if (currIndex === 6) {
            return anticipationTL;
        }


        if (HTH.model.nearWinReels[currIndex]) {
            this._firstCall++;
            anticipationTL.add(() => {
                if (!HTHGameConfig.isAnticipationPlaying) {
                    HTH.reelAnticipationTop.playAnticipationReelEffect();
                    HTHSound.playTrack(HTHSound.SCATTER_ANTICIPATION);
                    HTHSound.fadeMusic(0.6, 200);
                    HTHGameConfig.isAnticipationPlaying = true;
                    this._isPlayingAnticipation=true;
                }
            }, 0)


            anticipationTL.add(() => {
                if(this._isPlayingAnticipation){
                    this._animations[currIndex].show();
                    this._animations[currIndex].playLoop();
                }
            }, 0);

            return anticipationTL;
        }
        return anticipationTL;
    }

    private init() {


        this._animations = ArrayHelper.initArrayWithValues(6, (i: number) => {
            const sparkleAnim: TimelineSprite = new TimelineSprite((HTH.assetLoader.getTextures("sReelAnticipationSiren")));
            sparkleAnim.position.set(i * 120, -52);
            sparkleAnim.anchor.set(0.5, 0.5);
            sparkleAnim.blendMode = PIXI.BLEND_MODES.ADD;
            sparkleAnim.name = "sparkleAnim"+i;
            sparkleAnim.hide();
            this.addChild(sparkleAnim);
            return sparkleAnim;
        });
        this.position.set(HTHGameConfig.reelAreaPos.x, HTHGameConfig.reelAreaPos.y);
    }
}